import CustomerForm from "./CustomerForm.vue";

export default [
  {
    path: '/form/:id',
    name: 'form',
    component: CustomerForm,
    meta: { requiresAuth: false }
  }
]